import type * as React from 'react'
import { forwardRef } from 'react'
import { Popover } from '@buffer-mono/popcorn'

type ToggleTipElement = React.ElementRef<typeof Popover.Content>
type ToggleTipProps = {
  /**
   * Content displayed inside the tooltip
   */
  content: React.ReactNode
  /**
   * Children is the trigger of the tooltip
   */
  children: React.ReactNode
  /**
   * Controls whether the tooltip is open
   */
  open?: boolean
  /**
   * Callback when the tooltip is opened or closed
   */
  onOpenChange?: (open: boolean) => void
}

const ToggleTip = forwardRef<ToggleTipElement, ToggleTipProps>(
  ({ content, children, open, onOpenChange }: ToggleTipProps, ref) => {
    return (
      <Popover open={open} onOpenChange={onOpenChange}>
        <Popover.Trigger>{children}</Popover.Trigger>
        <Popover.Content
          ref={ref}
          side="right"
          align="center"
          arrow={true}
          size="medium"
        >
          {content}
        </Popover.Content>
      </Popover>
    )
  },
)

ToggleTip.displayName = 'ToggleTip'

export { ToggleTip }
export type { ToggleTipProps }
